import { isEqual } from 'lodash';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import productService from '../product-service';
import { formatNumber, formatValue, handleImageError } from '../../../base/common/utils';
import { Loader, NoResult } from '../../../misc/loader-utils';

import Badge from './badge';

import placeholderImage from '../../../../images/product_placeholder.png';
import linkoutIcon from '../../../../images/icons/linkout.svg';

class CartSiblings extends Component {
  constructor(props) {
    super(props);

    this.service = productService;
    this.query = null;

    this.state = {
      loading: true,
      showNoResult: false,
      stats: {},
    };
  }

  componentDidMount() {
    if (this.props.product) {
      this.queryCartData();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(prevProps.product, this.props.product) ||
      !isEqual(prevProps.currentDateRange, this.props.currentDateRange)
    ) {
      this.queryCartData();
    }
  }

  queryCartData() {
    this.setState({
      loading: true,
      showNoResult: false,
    });
    this.query = this.props.product.product_name;

    const params = {
      ...this.props.params,
      merch_id: this.props.product.merch_id,
      product_name: this.props.product.product_name,
      date_range: this.props.currentDateRange,
    };

    return this.service
      .queryCartData(this.props.pubId, params)
      .then(cartData => {
        // If a more recent call for cart has been made, return without modifying state
        if (this.query !== params.product_name) return;

        if (!cartData.stats.length) {
          this.showNoResult();
        } else {
          this.setState({
            stats: cartData,
            loading: false,
            showNoResult: false,
          });
        }
      })
      .catch(err => {
        this.showNoResult();
      });
  }

  showNoResult() {
    this.setState({
      loading: false,
      showNoResult: true,
    });
  }

  render() {
    const { stats } = this.state;
    const products = this.state.stats.stats;
    const cartStats = stats.cart_summary;

    const cartSiblings =
      !this.state.loading && !this.state.showNoResult
        ? products.map((product, i) => {
            const productLabel = this.service.getProductLabel(product);

            const productLinkout = product.store_page_url ? (
              <img src={linkoutIcon} alt="Visit product page" className="link-out" />
            ) : null;
            const logoUrl = this.props.logoMap[product.merch_id];
            const imageUrl = product.image_url || logoUrl || placeholderImage;

            const productPrice =
              product.sale_percent > 5 ? (
                <div className="prices">
                  <span className="value sale">{this.service.displayPrice(product, 'sale')}</span>
                  <span className="value original">{this.service.displayPrice(product)}</span>
                </div>
              ) : (
                <span className="value">{this.service.displayPrice(product)}</span>
              );

            return (
              <div key={i} className="cart-product">
                <div
                  className="image-container"
                  onClick={() => this.props.trackLinkOut(product.store_page_url)}
                >
                  <a href={product.store_page_url} target="_blank" rel="noopener noreferrer">
                    <img
                      src={imageUrl}
                      alt={`${productLabel}`}
                      className="product-image"
                      onError={e => handleImageError(e, logoUrl)}
                    />
                    {productLinkout}
                  </a>
                </div>
                <Badge product={product} currentTab="all" />
                <div className="cart-product-metadata">
                  <h3 className="product-label">{productLabel}</h3>
                  <div className="product-info">
                    <div className="price">{productPrice}</div>
                    <div className="quantity">
                      <span>{formatNumber(product.total_quantity)}</span>
                      <label>Purchased</label>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        : null;

    const totals =
      !this.state.loading && !this.state.showNoResult ? (
        <>
          <span className="cart-total-units">
            <label>Products purchased with</label>
            <span>{formatValue(cartStats.total_bought_with)}</span>
          </span>
          <span className="cart-aov">
            <label>Average Cart Value</label>
            <span>{formatValue(cartStats.aov, 'currency')}</span>
          </span>
        </>
      ) : null;

    return (
      <div className="cart">
        <div className="header">
          <h3>What else is in their cart?</h3>
          {totals}
        </div>
        <Loader loading={this.state.loading} />
        <NoResult type="cart-explorer" noResult={!this.state.loading && this.state.showNoResult} />
        <div className={`cart-siblings ${this.props.scrollable}`}>{cartSiblings}</div>
      </div>
    );
  }
}

export default withRouter(CartSiblings);
